export default __webpack_public_path__ + "static/media/Natasha Lim.97d0434c.jpg";